import { DataAnalytics, DataObject } from './common';
export var SpendingTrendsDataType;
(function (SpendingTrendsDataType) {
    SpendingTrendsDataType["seeYourSpendingTrends"] = "see your spending trends";
    SpendingTrendsDataType["xButton"] = "x button";
    SpendingTrendsDataType["sort"] = "sort";
    SpendingTrendsDataType["viewAll"] = "view all";
    SpendingTrendsDataType["backToActivity"] = "back to activity";
    SpendingTrendsDataType["customValue"] = "";
})(SpendingTrendsDataType || (SpendingTrendsDataType = {}));
var spendingTrendsPageNames = {
    view: 'view',
    expandedView: 'expanded view',
    noPurchase: 'no purchase',
    error: 'error'
};
var spendingTrendsMessage = {
    view: '',
    expandedView: '',
    noPurchase: 'No purchases to show',
    error: "we're having trouble retrieving your information"
};
var spendingTrendsErrorMessage = {
    view: '',
    expandedView: '',
    noPurchase: '',
    error: 'please try again later'
};
var spendingTrendsMessageType = {
    view: '',
    expandedView: '',
    noPurchase: '',
    error: '500'
};
export var getSpendingTrendsAnalyticsProps = function (isOpen) {
    return {
        banner: {
            'data-type': SpendingTrendsDataType.seeYourSpendingTrends,
            'data-reason': '',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        xButton: {
            'data-type': SpendingTrendsDataType.xButton,
            'data-reason': 'close',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        chart: {
            'data-reason': '',
            'data-object': DataObject.donut,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        amountSpent: {
            'data-type': SpendingTrendsDataType.sort,
            'data-reason': 'amount spent',
            'data-object': isOpen ? DataObject.highToLow : DataObject.lowToHigh,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        viewAllCategories: {
            'data-type': SpendingTrendsDataType.viewAll,
            'data-reason': 'spending categories',
            'data-object': isOpen ? DataObject.toggleOff : DataObject.toggleOn,
            'data-analytics': DataAnalytics.clickTrackingEvent
        },
        backToActivity: {
            'data-type': SpendingTrendsDataType.backToActivity,
            'data-reason': '',
            'data-object': DataObject.button,
            'data-analytics': DataAnalytics.clickTrackingEvent
        }
    };
};
export var getSpendingTrendsAnalyticsEvent = function (event) { return ({
    errorMessage: spendingTrendsErrorMessage[event],
    pageFunction: 'spending trends',
    pageKind: 'activity',
    pageName: spendingTrendsPageNames[event],
    pageSubFunction: '',
    message: spendingTrendsMessage[event],
    messageType: spendingTrendsMessageType[event]
}); };
//# sourceMappingURL=spending-trends.js.map